export default __webpack_public_path__ + "media/images/services-03-350x220-ce72139d5c1bb4b0b0674abc0a4987c5.jpg";